import { useQuery } from "react-query";

import { fetchDeploymentScans } from "@api";
import { useOrg } from "@hooks/useOrg";
import { SECOND, WEEK } from "@utils";

const REFETCH_RECENT_SCANS_INTERVAL_FAST = 5 * SECOND;
const REFETCH_RECENT_SCANS_INTERVAL_SLOW = 60 * SECOND;
const MAX_RECENT_SCANS_WINDOW = WEEK;
/*
 * Returns query result with scans from current selected org,
 * filtered by the provided params. If 'since' is not given
 * or is longer than one week ago, it is overridden to one week
 * in order to avoid too large of a response.
 */
export const useScans = (
  fastRefresh?: boolean,
  searchParams?: URLSearchParams
) => {
  const org = useOrg();

  const since = searchParams?.get("since");
  const weekAgo = Date.now() - MAX_RECENT_SCANS_WINDOW;
  const params = new URLSearchParams(searchParams);
  if (!since || parseInt(since) * 1000 < weekAgo) {
    params?.set("since", (weekAgo / 1000).toString());
  }

  return useQuery(
    ["scans", { org }, searchParams, fastRefresh],
    () =>
      fetchDeploymentScans(org?.id!, params).then((response) => {
        return response.scans;
      }),
    {
      enabled: !!org,
      refetchInterval: fastRefresh
        ? REFETCH_RECENT_SCANS_INTERVAL_FAST
        : REFETCH_RECENT_SCANS_INTERVAL_SLOW,
    }
  );
};
